<template>
  <section class="hero vegas">
      <div class="hero__content container">
        <div class="hero__content--info">
          <h1 class="hero__title">
            DNA House at Bitcoin 2025, Las Vegas
          </h1>
          <h2 class="hero__date">
            May 27th - 28th, 2025
          </h2>
          <a href="http://lu.ma/dnafund" target="_blank">
            <button class="hero__btn">
              Register Now
            </button>
          </a>
          <div class="venue-logo">
            <a href="https://maps.app.goo.gl/jfgBHL9T9UBYGGji6" target="_blank">
              <img src="@/assets/general/maggianos.svg" class="logo" alt="Maggiano's Logo">
            </a>
          </div>
        </div>
      </div>
    </section>
  </template>
  
  <script>

  export default {
    name: 'Hero',
    data () {
      return {
      }
    },
  }
  </script>
  
  <style lang="scss" scoped>
  @import "@/styles/components/hero.scss";

  .hero.vegas {
    padding: 100px 0 20px;
    min-height: 500px;
    background-image: linear-gradient(to bottom, rgb(0 0 0 / 90%) 0%, rgb(0 0 0 /65%)), url('~@/assets/general/vegas.jpg');
  }
  </style>